import React, {useMemo} from "react"
import SenarioRank from "../senarioRank"

export default function TrendRankingPage() {
  return useMemo(
    () => (
      <>
        <SenarioRank />
      </>
    ),
    [],
  )
}
